<template>
    <b-modal ref="mdlIdentityManagerEdit" :title="title" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Nome Applicativo</label>
                <b-input v-model="jsonData.applicationName" :readonly="readOnly"></b-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">URL Request</label>
                <b-input v-model="jsonData.urlRequest" :readonly="readOnly"></b-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">URL Callback</label>
                <b-input v-model="jsonData.urlCallback" :readonly="readOnly"></b-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Client Id</label>
                <b-input-group>
                    <b-input type="text" v-model="jsonData.clientId" :readonly="readOnly"></b-input>
                    <b-input-group-append v-if="!readOnly">
                        <b-button @click="jsonData.clientId = generateUUID()" variant="outline-secondary"><font-awesome-icon size="lg" icon="hammer" tabindex="-1" /></b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Client Secret</label>
                <b-input-group>
                    <b-input :type="!lookPassword ? 'password' : 'text'" v-model="jsonData.clientSecret" :readonly="readOnly"></b-input>
                    <b-input-group-append>
                        <b-button v-if="!readOnly" @click="() => (jsonData.clientSecret = generateUUID())" variant="outline-secondary"><font-awesome-icon size="lg" icon="hammer" tabindex="-1" /></b-button>
                        <b-button @click="lookPassword = !lookPassword" variant="outline-secondary"><font-awesome-icon size="lg" :icon="lookPassword ? 'eye' : 'eye-slash'" tabindex="-1" /></b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">OTP</label>
                <b-select :options="otpOptions" v-model="jsonData.otp" :disabled="readOnly">
                    <template #first>
                        <b-select-option :value="null" disabled> - Seleziona OTP - </b-select-option>
                    </template>
                </b-select>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button v-if="!readOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!readOnly" size="md" variant="outline-success" @click="onClickSalva()">Salva</b-button>
            <b-button v-if="readOnly" size="md" variant="outline-primary" @click="onClickOk()">Ok</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/identitymanager",
            readOnly: false,
            jsonData: {
                applicationName: null,
                otp: null,
                urlCallback: null,
                urlRequest: null,
                clientId: null,
                clientSecret: null,
            },
            lookPassword: false,
            otpOptions: [
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },
    methods: {
        show(jsonData, readOnly) {
            let me = this;
            Object.assign(me.jsonData, jsonData);
            me.readOnly = readOnly;
            me.lookPassword = false;
            if (!me.jsonData.id) {
                me.title = "Nuovo Identity Manager";
            } else {
                me.title = me.readOnly ? "Visualizza Identity Manager" : "Modifica Identity Manager";
            }
            me.$refs.mdlIdentityManagerEdit.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlIdentityManagerEdit.hide();
        },
        onClickSalva() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveIdentityResponseSuccess, me.saveIdentityResponseError);
        },
        saveIdentityResponseSuccess(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlIdentityManagerEdit.hide();
            me.$bvToast.toast("Operazione andata a buon fine", {
                title: "Successo",
                variant: "Success",
                solid: true,
            });
        },

        saveIdentityResponseError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeleteIdentity(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa identity?", {
                    title: "Eliminazione Identity Manager",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteIdentity(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteIdentity(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteIdentitySuccess, me.deleteIdentityError);
        },
        deleteIdentitySuccess(response) {
            let me = this;
            me.$emit("deleteIdentity", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteIdentityError(response) {
            let me = this;
            me.$emit("deleteIdentity", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        generateUUID() {
            let UUID = self.crypto.randomUUID();
            return UUID;
        },
        onClickOk() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlIdentityManagerEdit.hide();
        },
    },
};
</script>

<style></style>
